import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { WordModel } from "../../../../../../Models/WordModel";
import { servicesFunctions } from "../../../../../../Services/ServicesFunctions";
import { toastsFunctions } from "../../../../../../Services/ToastFunctions";
import "./TranslateWithTimer.css";
import { useTranslation } from "react-i18next";

interface WordPair {
    hebrewWord: string;
    englishWord: string;
}

function TranslateWithTimer(): JSX.Element {

    const isLogin = useSelector((state: any) => state.authSlice)
    const navigate = useNavigate()
    const [words, setWords] = useState<WordPair[]>([])
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (!isLogin) {
            navigate("/")
            let must_be_logged_in_text = `${t("toast_functions_must_be_logged_in")}`
            toastsFunctions.toastError(must_be_logged_in_text)
        } else {
            servicesFunctions.getAllFavoriteWordsByUser().then((res: WordModel[]) => {
                const userWords = res.map(({ englishWord, hebrewWord }) => ({
                    hebrewWord,
                  englishWord,
                }));
                console.log(userWords);

                if(!userWords || userWords.length < 1){
                    const minimum_favorite_word_text = `${t("toast_functions_translate_timer_at_least_1_favorite_word")}`
                    toastsFunctions.toastError(minimum_favorite_word_text)
                    navigate("/dashboard");
                  }

                const shuffledWords = userWords.sort(() => Math.random() - 0.5);
                setWords(shuffledWords);
                
            })
        }

    }, [])
    const [currentWordIndex, setCurrentWordIndex] = useState<number>(0);
    // const [currentWordIndeCounting, setCurrentWordIndeCounting] = useState<number>(1);
    const [timeRemaining, setTimeRemaining] = useState<number>(60);
    const [userTranslation, setUserTranslation] = useState<string>("");
    const [countCorrect, setCountCorrect] = useState<number>(0);
    const [countUncorrect, setCountUncorrect] = useState<number>(0);
    const [gameComplete, setGameComplete] = useState<boolean>(false);
    const [correctAnswer, setCorrectAnswer] = useState<boolean>(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (timeRemaining > 0) {
                setTimeRemaining(timeRemaining - 1);
            } else {
                clearTimeout(timer);
                setCorrectAnswer(true);
            }
        }, 1000);

        return () => clearTimeout(timer);
    }, [timeRemaining]);


    function startGame() {
        setTimeRemaining(60);
        getNextWord();
        setCountUncorrect(0);
    }

    function resetGame() {
        const shuffledWords = words.sort(() => Math.random() - 0.5);
        setWords(shuffledWords);
        setTimeRemaining(60);
        setUserTranslation("");
        setCountCorrect(0);
        setCurrentWordIndex(0)
        setCountUncorrect(0);
        startGame();
        setGameComplete(false);
        setCorrectAnswer(false);
    }


      function getNextWord() {
        if (currentWordIndex + 1 >= words.length) {
          gameOver();
          return;
        }
        setCurrentWordIndex(currentWordIndex + 1);
      }
      

    function checkAnswer() {
        const inputElemnt = document.getElementById("input");
        if (userTranslation.toLowerCase() === words[currentWordIndex].englishWord.toLocaleLowerCase()) {
            // Correct answer
            setCountCorrect(countCorrect + 1);
            inputElemnt!.style.border = "1px solid grey";
            getNextWord();
            setTimeRemaining(60);
        } else {
            // Incorrect answer
            inputElemnt!.style.border = "1px solid red";
            setCountUncorrect(countUncorrect + 1);
        }

        setUserTranslation("");
    }

    function endOfTime(){
        getNextWord();
        setCorrectAnswer(false);
        setCountUncorrect(countUncorrect + 1);
        setTimeRemaining(60);
    }

    function gameOver() {
        // Implement your game over logic here, e.g., show a final score or a message
        setGameComplete(true);
    }



    function handleKeypress(e: any) {
        if (e.keyCode === 13) {
            checkAnswer();
          }
    }
    return (
        <div className="TranslateWithTimer">

            {!gameComplete ? (
                <div className="game-container"  style={{ direction: i18n.language !== "en" ? "rtl" : "ltr" }}>
                  <p>{t("translate_game_question")} {currentWordIndex + 1 } {t("translate_game_of")} {words.length}</p>


                    <div className="word-container">
                        <span>{words[currentWordIndex]?.hebrewWord}</span>
                    </div>
                    <input
                        id="input"
                        type="text"
                        className={i18n.language !== "en" ? "text-right" : "text-left"}
                        value={userTranslation}
                        onChange={(e) => setUserTranslation(e.target.value)}
                        style={{textAlign: "left"}}
                        placeholder={t("translate_game_input_translate_placehodler")}
                        onKeyDown={handleKeypress}
                        />
                    {correctAnswer && <div className="end-of-time"><div className="text">{t("translate_game_the_correctt_word")} {words[currentWordIndex].englishWord}</div> <button className="next-button btn " onClick={endOfTime}>{t("translate_game_next_question")}</button> </div>}
                    {!correctAnswer && <div className="timer">{timeRemaining}</div>}
                    {!correctAnswer &&<progress max="60" value={timeRemaining}></progress>}
                    

                    {!correctAnswer && <button className="done-button btn " onClick={checkAnswer}>{t("translate_game_end_button")}</button>}
                    
                </div>
            ) : (
                <div className="game-footer">
                    <div className="game-data">
                        <div className="game-data-text">{t("translate_game_words_amount")} {words.length}</div>
                        <div className="game-data-text">{t("translate_game_successes")} {countCorrect}</div>
                        {/* <div className="game-data-text">כישלונות: {countUncorrect}</div> */}
                    </div>
                    <button className="reset-button" onClick={resetGame}>{t("translate_game_reset")}</button>
                </div>
            )}
        </div>
    );
}

export default TranslateWithTimer;
